import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import {
	fadeOutZoomOut,
	slideInFromBottomNFadeNZoom,
	slideInFromLeftNFadeNZoom,
	slideInFromRightNFadeNZoom,
	slideInFromTopNFadeNZoom,
} from '../../styles/animations';
import { borderColor, charmGray, white } from '../../styles/colors';

export const s = StyleSheet.create({
	trigger: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: 36,
		whiteSpace: 'nowrap',
		borderRadius: 6,
		border: `1px solid ${borderColor}`,
		backgroundColor: 'transparent',
		padding: `8px 12px`,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
		color: THEME.colors.text.main,
		outline: 'none',
		userSelect: 'none',
		width: 'fit-content',
		':placeholder': {
			color: '#64748b',
		},
		':focus-visible': {
			border: `1px solid #A1A1A1`,
		},
		':is([data-disabled])': {
			pointerEvents: 'none',
			opacity: 0.6,
		},
		':has(*) > span': {
			overflow: 'hidden',
			display: '-webkit-box',
			'-webkit-box-orient': 'vertical',
			'-webkit-line-clamp': 1,
		},
	},
	triggerChevron: {
		display: 'block',
		boxSizing: 'border-box',
		height: 16,
		width: 16,
		opacity: 0.5,
	},
	scrollUpButton: {
		position: 'fixed',
		top: 1,
		left: 1,
		right: 1,
		zIndex: 10,
		display: 'flex',
		cursor: 'default',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: 4,
		paddingBottom: 4,
		boxSizing: 'border-box',
		borderTopLeftRadius: 6,
		borderTopRightRadius: 6,
		backgroundColor: white,
	},
	scrollDownButton: {
		position: 'fixed',
		bottom: 1,
		left: 1,
		right: 1,
		zIndex: 10,
		display: 'flex',
		cursor: 'default',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: 4,
		paddingBottom: 4,
		boxSizing: 'border-box',
		borderBottomLeftRadius: 6,
		borderBottomRightRadius: 6,
		backgroundColor: white,
	},
	scrollButtonChevron: {
		display: 'block',
		boxSizing: 'border-box',
		height: 16,
		width: 16,
	},
	positioner: {
		zIndex: 50,
	},
	selectContent: {
		boxSizing: 'border-box',
		padding: 4,
		position: 'relative',
		//maxHeight: 384,
		maxHeight: `var(--available-height)`,
		width: `100%`,
		minWidth: `var(--anchor-width)`,
		overflowX: 'hidden',
		overflowY: 'auto',
		borderRadius: 6,
		borderWidth: 1,
		backgroundColor: white,
		color: `#0F172A`,
		boxShadow: `0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)`,
		origin: 'var(--transform-origin)',
		border: `1px solid ${borderColor}`,
		animationDuration: '150ms',
		animationTimingFunction: `cubic-bezier(0.4, 0, 0.2, 1)`,
		':is([data-state="closed"])': {
			animationName: fadeOutZoomOut,
		},
		':is([data-side="bottom"][data-open])': {
			animationName: slideInFromTopNFadeNZoom(),
		},
		':is([data-side="top"][data-open])': {
			animationName: slideInFromBottomNFadeNZoom(),
		},
		':is([data-side="left"][data-open])': {
			animationName: slideInFromRightNFadeNZoom(),
		},
		':is([data-side="right"][data-open])': {
			animationName: slideInFromLeftNFadeNZoom(),
		},
	},
	selectLabel: {
		padding: `6px 8px`,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		fontWeight: 'bold',
	},
	selectItem: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		cursor: 'default',
		select: 'none',
		borderRadius: 2,
		paddingTop: 6,
		paddingBottom: 6,
		paddingRight: 32,
		paddingLeft: 8,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		outline: 'none',
		color: THEME.colors.text.main,
		userSelect: 'none',
		':is([data-highlighted])': {
			backgroundColor: `#f4f5f7`,
		},
		':is([data-selected])': {
			background: `rgba(0, 102, 255, 0.1)`,
		},
		':is([data-disabled])': {
			pointerEvents: 'none',
			opacity: 0.5,
		},
	},
	selectCheckboxItem: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		cursor: 'default',
		select: 'none',
		borderRadius: 2,
		paddingTop: 6,
		paddingBottom: 6,
		paddingRight: 32,
		paddingLeft: 8,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		outline: 'none',
		color: THEME.colors.text.main,
		userSelect: 'none',
		':is([data-highlighted])': {
			backgroundColor: `#f4f5f7`,
		},
		':is([data-disabled])': {
			pointerEvents: 'none',
			opacity: 0.5,
		},
	},
	selectSeparator: {
		margin: `4px -4px`,
		height: 1,
		backgroundColor: `$f1f5f9`,
	},
	checkboxItemCheckWrapper: {
		border: `1px solid ${charmGray}`,
		width: 12,
		height: 12,
		flexShrink: 0,
		borderRadius: 4,
		display: `flex`,
		alignItems: 'center',
		justifyContent: 'center',
	},
	checkBoxItemCheckIndicator: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});
